import { render } from "./ProjectEditor.vue?vue&type=template&id=6ce16840&scoped=true"
import script from "./ProjectEditor.vue?vue&type=script&lang=js"
export * from "./ProjectEditor.vue?vue&type=script&lang=js"

import "./ProjectEditor.vue?vue&type=style&index=0&id=6ce16840&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce16840"]])

export default __exports__